import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OrganizationConfig } from '../models/OrganizationConfig';

@Injectable({
  providedIn: 'root'
})
export class OrganizationConfigService {


  constructor(private httpClient: HttpClient) { }

  get(): Observable<OrganizationConfig> {
    return this.httpClient.get<OrganizationConfig>(environment.apiUrl + "organization-configs");
  }

  save(organizationConfig: OrganizationConfig): Observable<void> {
    return this.httpClient.post<void>(environment.apiUrl + "organization-configs", organizationConfig);
  }

  delete(): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "organization-configs");
  }
}
